module.exports = __webpack_public_path__ + "static/menu-bf13af0bcb03a6ef4ca9922fa1ac6f2c.jpg";